var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"section-1"},[_vm._m(0),_c('div',[_c('Search')],1)]),_c('Chatbot'),_c('HomeContent')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h1',[_c('span',{staticClass:"blue"},[_vm._v("Dein individuelles Skript.")]),_vm._v(" Schemata und Definitionen. Kostenlos. ")])
}]

export { render, staticRenderFns }